import styled from '@emotion/styled';
import moment from 'moment';
import React from 'react';

const Cards = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
`;

const StyledCardTimeStamp = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  font-size: 14px;
  color: ${props => props.theme.subtleText};
  background-color: rgba(0, 0, 0, 0.3);
`;

const CardTitle = styled.h2`
  text-align: center;
  width: 100%;
  font-weight: bold;
  padding: 5px 10px;
`;

const CardTimeStamp = ({ createdAt, updatedAt }) => {
  const timeStamp = updatedAt || createdAt;

  return (
    <StyledCardTimeStamp>
      <span style={{ marginRight: `8px`, padding: `2px 0px`, margin: `0px` }}>
        {new Date(timeStamp).toDateString()}
        {` `}
        {moment(timeStamp).fromNow()}
      </span>
    </StyledCardTimeStamp>
  );
};

const CardByLine = styled.div`
  display: flex;
  padding: 2px 0px;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #111;
  font-size: 14px;

  span {
    padding: 2px 8px;
    border-radius: ${props => props.theme.radius};
    margin: 0px 5px;
    :hover {
      background-color: #111;
    }
  }
`;

const CardDescription = styled.div`
  text-align: center;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: ${props => props.theme.subtleText};
  padding: 5px 10px 10px 10px;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  flex-shrink: 1;
`;

const Card = styled.div`
  margin: 10px 8px;
  margin-top: 0px;
  border-radius: 5px;
  flex-shrink: 0;
  flex: 1;
  width: 100%;
  max-width: 450px;
  min-width: 300px;
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.2s;
  background-color: #111;
  color: #eee;
  border: 1px solid #222;
  overflow: hidden;

  :hover {
    transform: scale(1.02);
    border: 1px solid ${props => props.theme.outlineFocused};
  }
`;

const CardContainer = styled.div`
  margin: 10px 10px;
  box-sizing: border-box;
  flex-shrink: 0;
  flex: 1;
  display: flex;
  width: 40%;
  flex-direction: column;
  align-items: flex-start;
  max-width: 450px;
  min-width: 300px;
`;

export { Cards, CardContainer, Card, CardTitle, CardDescription, CardByLine, CardTimeStamp };
